"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReducer = void 0;
const react_1 = require("react");
const createReducer = (handlers) => (state, { type, data, dispatch }) => {
    const update = handlers[type] &&
        handlers[type](Object.assign(Object.assign({}, state), { dispatch }), ...data);
    if (update) {
        delete update.dispatch;
    }
    const hasUpdate = update && Object.keys(update).length > 0;
    return hasUpdate ? Object.assign(Object.assign({}, state), update) : state;
};
const createDispatch = (dispatch) => {
    const dispatchRef = (type, ...data) => {
        dispatch({
            type,
            data,
            dispatch: dispatchRef,
        });
    };
    return dispatchRef;
};
function useReducer(handlers, initialState) {
    const [state, reactDispatch] = (0, react_1.useReducer)(createReducer(handlers), initialState);
    const dispatch = (0, react_1.useMemo)(() => createDispatch(reactDispatch), [reactDispatch]);
    return [state, dispatch];
}
exports.useReducer = useReducer;
